var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinner3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 36.283,
    viewBox: "0 0 32 36.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85992",
    "data-name": "Path 85992",
    d: "M0,0H32V36.283H0Z",
    transform: "translate(-0.01 -0.209)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69013",
    "data-name": "Group 69013",
    transform: "translate(-0.461 -0.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_340",
    "data-name": "Mask Group 340",
    transform: "translate(0.471 0.434)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85964",
    "data-name": "Path 85964",
    d: "M79.474,508.413c0,.194-5.562.351-12.423.351s-12.423-.157-12.423-.351,5.562-.351,12.423-.351,12.423.157,12.423.351",
    transform: "translate(-51.018 -472.406)",
    fill: "#d8dfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85965",
    "data-name": "Path 85965",
    d: "M309.573,40.577v3.409a10.026,10.026,0,0,1-10.022,10.027h-1.4l1.557-1.606a8.429,8.429,0,0,0,8.264-8.421V41.379h-6.013l.2-1.6h6.615a.8.8,0,0,1,.8.8",
    transform: "translate(-277.348 -37.175)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85966",
    "data-name": "Path 85966",
    d: "M166.6,293.4v1.771H156.173V293.4a.4.4,0,0,1,.2-.349l.79-.445a4.344,4.344,0,0,0,2.213-3.786v-1.871h4.009v1.871A4.344,4.344,0,0,0,165.6,292.6l.79.445a.4.4,0,0,1,.2.349",
    transform: "translate(-145.395 -266.897)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85967",
    "data-name": "Path 85967",
    d: "M248.406,293.4v1.771h-1V293.4a.4.4,0,0,0-.2-.349l-.79-.445a4.344,4.344,0,0,1-2.213-3.786v-1.871h1v1.871a4.344,4.344,0,0,0,2.213,3.786l.79.445a.4.4,0,0,1,.2.349",
    transform: "translate(-227.205 -266.897)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85968",
    "data-name": "Path 85968",
    d: "M190.982,264.784v1.163a1,1,0,0,1-1,1h-4.41a1,1,0,0,1-1-1v-1.163Z",
    transform: "translate(-171.785 -246.301)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141635",
    "data-name": "Rectangle 141635",
    width: 4.009,
    height: 0.59,
    transform: "translate(13.985 20.649)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85969",
    "data-name": "Path 85969",
    d: "M147.087,392.464v7.019h-13.63v-7.019a.4.4,0,0,1,.4-.4h12.828a.4.4,0,0,1,.4.4",
    transform: "translate(-124.282 -364.596)",
    fill: "#343b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85970",
    "data-name": "Path 85970",
    d: "M310.709,392.464v7.019h-.8v-7.019a.4.4,0,0,0-.4-.4h.8a.4.4,0,0,1,.4.4",
    transform: "translate(-287.904 -364.596)",
    fill: "#262d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85971",
    "data-name": "Path 85971",
    d: "M132.454,489.059v.8a.4.4,0,0,1-.4.4H116.82a.4.4,0,0,1-.4-.4v-.8a.4.4,0,0,1,.4-.4h15.233a.4.4,0,0,1,.4.4",
    transform: "translate(-108.447 -454.372)",
    fill: "#262d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85972",
    "data-name": "Path 85972",
    d: "M327.746,489.059v.8a.4.4,0,0,1-.4.4h-.8a.4.4,0,0,0,.4-.4v-.8a.4.4,0,0,0-.4-.4h.8a.4.4,0,0,1,.4.4",
    transform: "translate(-303.738 -454.372)",
    fill: "#171c23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85973",
    "data-name": "Path 85973",
    d: "M171.473,415.192V418a.4.4,0,0,1-.4.4h-8.819a.4.4,0,0,1-.4-.4v-2.808a.4.4,0,0,1,.4-.4h8.819a.4.4,0,0,1,.4.4",
    transform: "translate(-150.673 -385.719)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85974",
    "data-name": "Path 85974",
    d: "M251.68,264.784v1.163a1,1,0,0,1-1,1h-.8a1,1,0,0,0,1-1v-1.163Z",
    transform: "translate(-232.483 -246.301)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85975",
    "data-name": "Path 85975",
    d: "M12.026,54.014h-2A10.026,10.026,0,0,1,0,43.986V40.577a.8.8,0,0,1,.8-.8H7.416v1.6H1.6v2.607a8.429,8.429,0,0,0,8.264,8.421Z",
    transform: "translate(-0.246 -37.175)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85976",
    "data-name": "Path 85976",
    d: "M110.507,17.046v.8c0,9.747-4.4,17.648-9.822,17.648s-9.822-7.9-9.822-17.648v-.8Z",
    transform: "translate(-84.696 -16.051)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85977",
    "data-name": "Path 85977",
    d: "M80.53,41.379h-.8q-.06-.791-.08-1.6h.8q.021.812.08,1.6",
    transform: "translate(-74.271 -37.175)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85978",
    "data-name": "Path 85978",
    d: "M129.96,219.572h-.8a12.77,12.77,0,0,1-1.267-1.665,8.277,8.277,0,0,0,.84.058,12.685,12.685,0,0,0,1.229,1.606",
    transform: "translate(-119.109 -202.733)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85979",
    "data-name": "Path 85979",
    d: "M190.982,264.784v.4a5.823,5.823,0,0,1-6.414,0v-.4a5.823,5.823,0,0,0,6.414,0",
    transform: "translate(-171.785 -246.301)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85980",
    "data-name": "Path 85980",
    d: "M246.472,17.046v.8c0,9.442-4.127,17.153-9.316,17.626,5.043-.479,6.911-8.188,6.911-17.626v-.8Z",
    transform: "translate(-220.661 -16.051)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85981",
    "data-name": "Path 85981",
    d: "M98.313,1a1,1,0,0,1-1,1H77.668a1,1,0,1,1,0-2.005H97.311a1,1,0,0,1,1,1",
    transform: "translate(-71.5 -0.208)",
    fill: "#a76e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85982",
    "data-name": "Path 85982",
    d: "M110.507,28.41c0,.269,0,.535-.01.8H90.874c-.006-.267-.01-.533-.01-.8Z",
    transform: "translate(-84.696 -26.613)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85983",
    "data-name": "Path 85983",
    d: "M341.108,1a1,1,0,0,1-1,1h-2.2A1,1,0,0,0,337.9,0h2.2a1,1,0,0,1,1,1",
    transform: "translate(-314.295 -0.208)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85984",
    "data-name": "Path 85984",
    d: "M188.1,415.192V418a.4.4,0,0,1-.4.4h-7.957c1.62-.032,6.955-.377,6.955-3.61h1a.4.4,0,0,1,.4.4",
    transform: "translate(-167.299 -385.719)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85985",
    "data-name": "Path 85985",
    d: "M167.531,422.278v-1.641a.164.164,0,0,1,.164-.164h3.594s-2.856.3-3.758,1.8",
    transform: "translate(-155.951 -391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85986",
    "data-name": "Path 85986",
    d: "M139.846,399.55v-1.641a.164.164,0,0,1,.164-.164H143.6s-2.856.3-3.758,1.8",
    transform: "translate(-130.22 -369.876)",
    fill: "#4e5868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85987",
    "data-name": "Path 85987",
    d: "M112.219,66.58c-2.177,0-8.214-4.595-8.946-15.442h2.381c.6,13.272,6.564,15.442,6.564,15.442",
    transform: "translate(-96.229 -47.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85988",
    "data-name": "Path 85988",
    d: "M170.37,322.608s2.806-1.8,2.806-4.412v4.412Z",
    transform: "translate(-158.589 -295.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85989",
    "data-name": "Path 85989",
    d: "M83.347,5.682v.6h-1a.6.6,0,0,1,.6-.6Z",
    transform: "translate(-76.778 -5.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85990",
    "data-name": "Path 85990",
    d: "M353.892,39.775c-.014.541-.04,1.077-.082,1.6H352.1l.2-1.6Z",
    transform: "translate(-327.489 -37.175)",
    fill: "#745252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85991",
    "data-name": "Path 85991",
    d: "M300.331,218.248a13.065,13.065,0,0,1-1.253,1.641h-.93l.71-.73.848-.876c.21,0,.419-.016.625-.034",
    transform: "translate(-277.348 -203.05)",
    fill: "#745252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner3);
export default __webpack_public_path__ + "static/media/winner3.a695a67172dc2ae0ad9e7cf65ad54c81.svg";
export { ForwardRef as ReactComponent };